import PropTypes from 'prop-types';
import currencyShape from './currency';

export default PropTypes.arrayOf(
  PropTypes.shape({
    pnr: PropTypes.string,
    amount: PropTypes.number,
    currency: currencyShape,
    method: PropTypes.string,
    firstDate: PropTypes.string,
    firstDepartureStationShortCode: PropTypes.string,
    firstDepartureStationName: PropTypes.string,
    firstArrivalStationShortCode: PropTypes.string,
    firstArrivalStationName: PropTypes.string,
    date: PropTypes.string,
    time: PropTypes.string
  })
);
